import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import LandingPage from './pages/LandingPage';
import AdminUserManagement from './pages/AdminUserManagement';
import ChangeUserPreferences from './pages/ChangeUserPreferences';
import ChangeEMail from './pages/ChangeEMail';
import ChangePassword from './pages/ChangePassword';
import ForgotPassword from './pages/ForgotPassword';
import AddRegion from './pages/AddRegion';
import RegionWorkspace from './pages/RegionWorkspace';
import ModifyAdminParameters from './pages/ModifyAdminParameters'; 
import AdminOverview from './pages/AdminOverview';
import ComputationQueueManager from './pages/ComputationQueueManager';

function App() {
  return (
    <Router>
      <div className="App">
        <div className="content">
          <Routes>
            <Route exact path='/' element={<LandingPage/>} />
            <Route exact path='/login' element={<Login />} />
            <Route exact path='/admin-users' element={<AdminUserManagement />} />
            <Route exact path='/user/preferences' element={<ChangeUserPreferences />} />
            <Route exact path='/change-email' element={<ChangeEMail />} />
            <Route exact path='/change-password' element={<ChangePassword />} />
            <Route exact path='/forgot-password' element={<ForgotPassword />} />
            <Route exact path='/add-region' element={<AddRegion />} />
            <Route exact path='/region-overview/:regionId' element={<RegionWorkspace />} />
            <Route exact path='/admin-parameters' element={<ModifyAdminParameters />} />
            <Route exact path='/admin-overview' element={<AdminOverview />} />
            <Route exact path='/computation-queue-manager' element={<ComputationQueueManager />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
